'use client';

import { useEffect, useState } from 'react';
import { coverChromeNow, useCoverChrome } from '@/lib/ui/chrome-cover';
import { SPLASH_ATTR } from '@/lib/splash/boot';

const ID = 'seasonal-splash';

/**
 * Stands the Mucka Bar down while a seasonal splash plays. The native glass
 * bar is a view above the WebView, so no z-index covers it, and the app
 * hydrates (and would raise the bar) partway through the animation.
 */
export default function SplashCover() {
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    // Up for the whole time the overlay is: the still M ("hold") as much as the
    // animation. The app hydrates during the hold, which is when MobileNav raises
    // the bar.
    if (!root.hasAttribute(SPLASH_ATTR)) return;
    coverChromeNow(ID);
    setPlaying(true);
    const watch = new MutationObserver(() => {
      if (!root.hasAttribute(SPLASH_ATTR)) setPlaying(false);
    });
    watch.observe(root, { attributes: true, attributeFilter: [SPLASH_ATTR] });
    return () => watch.disconnect();
  }, []);

  useCoverChrome(ID, playing);
  return null;
}
